import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../../lib/result-codes";
import { deleteEvent as deleteEventApi } from "../api/event.api";

interface UseDeleteEventReturn {
  deleteEvent: (id: string) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useDeleteEvent = (): UseDeleteEventReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteEvent = useCallback(async (id: string): Promise<void> => {
    try {
      setLoading(true);
      setError(null);
      await deleteEventApi(id);
    } catch (deleteError: unknown) {
      setError(getApiErrorMessage(deleteError, "Failed to delete event"));
      throw deleteError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { deleteEvent, loading, error };
};
